module.exports = __webpack_public_path__ + "img/login.60ec8eb9.png";